// ---------------------------------------------------------------------------
// Test Mode — simulated calendar events (CLE-252).
//
// `GET /api/calendar/events` returns a CalendarEventsResponse OBJECT
// ({ events, totalEvents, conflicts, lastSyncAt }), not an array. Before this
// builder the mock router fell through to the graceful `{ data: [] }` fallback,
// so the Dashboard's TodaysEventsCard (and the Daily Summary calendar section)
// read `data.events.length` on an array, threw a TypeError during render, and
// blanked the entire Dashboard. Returning a properly shaped object fixes that.
// ---------------------------------------------------------------------------

import { isoDateTime } from './company';
import type { CalendarEventsResponse } from '../lib/calendarApi';

/** A small, coherent set of "today" events for the simulated Clean Code Culture team. */
export function buildCalendarEvents(): CalendarEventsResponse {
  const events: CalendarEventsResponse['events'] = [
    {
      id: 'cal-evt-1',
      googleEventId: null,
      calendarId: 'work',
      calendarName: 'Clean Code Culture',
      summary: 'Daily standup echipă',
      description: 'Sincronizare zilnică sprint.',
      location: 'Sala Cluj / Google Meet',
      startTime: isoDateTime(0, 9, 30),
      endTime: isoDateTime(0, 9, 45),
      allDay: false,
      status: 'CONFIRMED',
      color: null,
    },
    {
      id: 'cal-evt-2',
      googleEventId: null,
      calendarId: 'work',
      calendarName: 'Clean Code Culture',
      summary: 'Review proiect — retailer e-commerce',
      description: 'Demo milestone 2 cu clientul.',
      location: 'Google Meet',
      startTime: isoDateTime(0, 13, 0),
      endTime: isoDateTime(0, 14, 0),
      allDay: false,
      status: 'CONFIRMED',
      color: null,
    },
    {
      id: 'cal-evt-3',
      googleEventId: null,
      calendarId: 'personal',
      calendarName: 'Personal',
      summary: 'Prânz cu echipa',
      description: null,
      location: null,
      startTime: isoDateTime(0, 12, 0),
      endTime: isoDateTime(0, 12, 45),
      allDay: false,
      status: 'CONFIRMED',
      color: null,
    },
  ];

  return {
    events,
    totalEvents: events.length,
    conflicts: [],
    lastSyncAt: isoDateTime(0, 8, 0),
  };
}
